export const DATE = 'Date';
export const PROPERTY = 'Property';
export const OFFER = 'Offer';
export const STATUS = 'Status';
export const ACTIONS = 'Actions';
